import {Navigate, Outlet} from 'react-router';

import {useAuth} from '@/providers/components/authProvider';

import {LoadingSpinningLogoComponent} from '@/components/loadingSpinningLogoComponent';

const ProtectedRoutes = () => {
  const {
    isAuthenticated,
    userAccounts: {verification},
    authenticating,
  } = useAuth();

  // Show only loading state while authenticating
  if (authenticating) {
    return <LoadingSpinningLogoComponent />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/sign-in" replace />;
  }

  if (verification?.is_new_user) {
    return <Navigate to="/register-details" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoutes;
